
import { venuesListData } from '../../../mocks/venuesList';

interface VenueListCardProps {
  venue: typeof venuesListData[number];
}

export default function VenueListCard({ venue }: VenueListCardProps) {
  return (
    <article className="bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group">
      <div className="p-6">
        <div className="flex items-start gap-4 mb-4">
          <div className="w-11 h-11 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0 group-hover:bg-gray-800 transition-colors">
            <i className="ri-building-2-line text-lg"></i>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-bold text-gray-900 leading-tight mb-1">{venue.name}</h3>
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <i className="ri-group-line text-xs"></i>
              収容：{venue.capacity}
            </span>
          </div>
        </div>

        <div className="space-y-2 mb-5">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-train-line text-gray-400 text-sm"></i>
            </div>
            <span>{venue.access}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-gray-400 text-sm"></i>
            </div>
            <span>{venue.note}</span>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-4">
          <a
            href={venue.url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 text-sm text-gray-700 font-medium hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-global-line text-sm"></i>
            公式サイト・予約
            <i className="ri-external-link-line text-xs text-gray-400"></i>
          </a>
        </div>
      </div>
    </article>
  );
}
